<template>
  <div class="autoReply">
    <h2 class="normal">自动问答管理</h2>

    <div class="table" :style="{ height: tableHeight + 'px' }">
      <div class="menu">
        <el-button
          type="primary"
          @click.stop="append(currentData, currentNode);"
          >新增类别</el-button
        >
        <el-button
          type="primary"
          @click.stop="append(currentData, currentNode, true);"
          >新增答案</el-button
        >
        <el-button
          type="primary"
          @click.stop="modify(currentData, currentNode);"
          >修改</el-button
        >
        <el-button
          type="primary"
          @click.stop="remove(currentData, currentNode);"
          >删除</el-button
        >
        <div class="normal">
          <el-button type="primary" @click.stop="fold">折叠</el-button>
          <el-button
            :type="movable ? 'primary' : 'plain'"
            @click="movable = !movable;"
            >移动</el-button
          >
        </div>
        <el-input
          class="normal"
          clearable
          placeholder="输入关键字搜索答案"
          v-model="filterText"
        >
        </el-input>
        <div class="tree-box" :style="{ height: tableHeight - 150 + 'px' }">
          <el-tree
            :data="treeData"
            :props="defaultProps"
            @current-change="handleCurrentChange"
            ref="tree"
            highlight-current
            node-key="id"
            default-expand-all
            :filter-node-method="filterNode"
            @node-drop="handleDrop"
            draggable
            :allow-drop="allowDrop"
          ></el-tree>
        </div>
      </div>
      <div class="line"></div>
      <div class="question">
        <div>
          <div class="input-box">
            <el-input
              clearable
              placeholder="输入手动录入的问题"
              v-model="questionWords"
            >
            </el-input>
          </div>
          <el-button type="primary" @click.stop="addQuestion"
            >手动录入问题</el-button
          >
          <el-button type="primary" @click.stop="toLoadQuestion"
            >表格导入问题</el-button
          >
        </div>

        <div class="normal">
          操作：
          <el-select v-model="operate" @change="getQuestion">
            <el-option label="匹配" value="匹配"> </el-option>
            <el-option label="核对" value="核对"> </el-option>
          </el-select>
          <span style="margin-left: 20px;">状态：</span>
          <el-select
            v-model="matchStatus"
            v-if="operate === '匹配'"
            @change="getQuestion"
          >
            <el-option label="未匹配" value="未匹配"> </el-option>
            <el-option label="已匹配" value="已匹配"> </el-option>
            <el-option label="待定" value="待定"> </el-option>
            <el-option label="疑难" value="疑难"> </el-option>
            <el-option label="不答" value="不答"> </el-option>
          </el-select>
          <el-select v-model="checkStatus" v-else @change="getQuestion">
            <el-option label="未核对" value="未核对"> </el-option>
            <el-option label="已核对" value="已核对"> </el-option>
            <el-option label="二轮核对" value="二轮核对"> </el-option>
            <el-option label="灌水" value="灌水"> </el-option>
          </el-select>
        </div>

        <div>
          <el-input
            v-model="tableSearch"
            size="mini"
            placeholder="输入关键字搜索"
          />
        </div>

        <div
          class="normal"
          v-if="operate === '匹配' && matchStatus === '已匹配'"
        >
          <el-date-picker
            v-model="checkDate"
            type="date"
            value-format="yyyy-MM-dd"
            @change="init();"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>

        <div class="mtop">
          <el-table
            :data="filterResult"
            border
            stripe
            :height="tableHeight - 170 - 30"
          >
            <el-table-column
              prop="content"
              :label="'问题' + allQuestion.length + '/' + filterResult.length"
            >
            </el-table-column>
            <el-table-column label="操作" width="600">
              <template slot-scope="scope">
                <!--
                  <el-button size="mini" type="plain" @click="checkAutoReply(scope.row.content)">检查</el-button>
                -->
                <el-button
                  size="mini"
                  type="plain"
                  @click="matchQuestion(scope.row, 'cancel');"
                  v-if="scope.row.status > 1 && scope.row.status < 4"
                  >取消匹配</el-button
                >
                <el-button
                  size="mini"
                  type="plain"
                  @click="matchQuestion(scope.row, 'cancel');"
                  v-else-if="scope.row.status === 7"
                  >取消匹配</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="matchQuestion(scope.row, 'match');"
                  v-else
                  >匹配</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  @click="matchQuestion(scope.row, 'wait');"
                  v-if="!(operate === '匹配' && matchStatus === '待定')"
                  >待定</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  @click="matchQuestion(scope.row, 'diff');"
                  v-if="
                    operate === '匹配' &&
                      ['未匹配', '待定', '不答'].includes(matchStatus)
                  "
                  >疑难</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="matchQuestion(scope.row, 'delete');"
                  v-if="operate === '匹配' && matchStatus !== '已匹配'"
                  >删除</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="matchQuestion(scope.row, 'check');"
                  v-if="operate === '核对' && scope.row.status < 3"
                  >核对正确</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="matchQuestion(scope.row, 'check2');"
                  v-if="
                    operate === '核对' &&
                      (scope.row.status == 3 || scope.row.status == 9)
                  "
                  >二轮核对</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="remarkQuestion(scope.row);"
                  >修改</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="matchQuestion(scope.row, 'silence');"
                  v-if="
                    (operate === '匹配' &&
                      (matchStatus === '疑难' || matchStatus === '待定')) ||
                      matchStatus === '未匹配'
                  "
                  >不答</el-button
                >

                <el-button
                  size="mini"
                  type="primary"
                  @click="matchQuestion(scope.row, 'water');"
                  v-if="operate === '核对' && scope.row.status == 7"
                  >灌水</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  @click="matchQuestion(scope.row, 'diff');"
                  v-if="operate === '核对'"
                  >疑难</el-button
                >
                <el-button
                  type="success"
                  @click="joinExamine(scope);"
                  :disabled="scope.row.label&& scope.row.label.includes('政策测试集')"
                >
                  {{ buttonContent }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination
          background
          @current-change="changePage"
          layout="prev, pager, next"
          :page-size="pageSize"
          prev-text="上一页"
          next-text="下一页"
          v-model="page"
          :total="allQuestion.length"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  
  data() {
    return {
      oneReply: null,
      replyWays: ["数据库查询", "小程序功能", "小程序文章", "文本", "图文"],
      buttonContent: "政策测试集",
      defaultProps: {
        children: "children",
        label: "oName",
        isLeaf: "leaf"
      },
      tableHeight: 500,
      currentData: null,
      currentNode: null,
      treeData: null,
      filterText: "",
      questionWords: "",
      questionList: [],
      operate: "匹配",
      matchStatus: "未匹配",
      checkStatus: "未核对",
      tableSearch: "",
      checkDate: "",
      lmap: {
        "1": "①",
        "2": "②",
        "3": "③",
        "4": "④",
        "5": "⑤",
        "6": "⑥",
        "7": "⑦"
      },
      movable: false,
      allQuestion: [],
      page: 1,
      pageSize: 1000,
    
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "login") {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      let origin = this.$options.data();
      Object.assign(this.$data, origin);
      this.init();
    }
    this.$route.meta.isBack = false;
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    filterResult: {
      handler(val) {
        console.log(12121231213212);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    filterResult() {
      console.log('3====3')

      let s = this.tableSearch;
      if (s) {
        return this.allQuestion.filter(x => {
          return x.content.includes(s);
        });
      }
      return this.questionList;
    }
  },
  created() {
    document.onkeydown = function(e) {
      if (e.keyCode === 13) {
        return false;
      }
    };
  },
  methods: {
    init() {
      let that = this;
      that.$nextTick(function() {
        this.tableHeight = window.innerHeight - 60;
      });
      let params = {
        operate: that.operate,
        status: that.checkStatus
      };
      if (that.operate === "匹配" && that.matchStatus !== "已匹配") {
        params = {};
      }
      that.$open();
      that.$axios
        .get(that.$url_prefix + "getAllReply", {
          params: params
        })
        .then(res => {
          that.treeData = res.data.data;
          that.currentData = null;
          that.currentNode = null;
          that.getQuestion();
          if (params.operate) {
            that.$nextTick(function() {
              that.$refs.tree.filter("match");
            });
          }
        })
        .catch(err => {
          console.log("getAllReply err", err);
        });
    },

    saveReply() {
      let that = this;
      let obj = that.oneReply;
      if (!obj.type) {
        that.$message.error("请填写问答类型");
        return;
      }
      if (!obj.name) {
        that.$message.error("请填写问答名称");
        return;
      }
      if (!obj.way) {
        that.$message.error("请填写回复方式");
        return;
      }
      obj.keywords = obj.keywords
        .map(x => {
          if (x) {
            return x.trim();
          }
        })
        .filter(x => x);
      obj.content = (obj.words && obj.words.trim()) || "";
      if (obj.way === "图文") {
        if (!obj.img) {
          that.$message.error("请上传图片");
          return;
        }
        obj.content = JSON.stringify({
          words: obj.content,
          img: obj.img
        });
      }
      let param = {
        db: "AutoReplyModel",
        model: "edit",
        item: JSON.stringify(obj)
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(res => {
          if (!res.data.success) {
            that.$message.error(res.data.msg);
            return;
          }
          that.$message({
            type: "success",
            message: "保存成功"
          });
          that.oneReply = null;
          that.init();
        })
        .catch(err => {
          console.log("保存失败", err);
        });
    },

    addItem(key) {
      this.oneReply[key].push("");
    },
    hasJoin(e) {
      if ("label" in e.row) {
        if (e.row.label.includes("政策测试集")) {
          return true;
        } else return false;
      } else return false;
    },
    toEdit(one) {
      console.log("toEdit", one);
      if (one.way === "图文") {
        let temp = JSON.parse(one.content);
        one.img = temp.img;
        one.words = temp.words;
      }
      this.oneReply = one;
    },
    toDel(one) {
      let that = this;
      that
        .$confirm("确定删除吗?", "提示", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          that.$axios
            .post(that.$url_prefix + "delete", {
              db: "AutoReplyModel",
              items: JSON.stringify([one])
            })
            .then(function(res) {
              if (res.data.success) {
                that.init();
              } else {
                that.$message.error("删除失败，请联系管理员");
              }
            })
            .catch(function(error) {
              console.log(error);
              that.$message.error("删除失败，请联系管理员");
            });
        })
        .catch(err => {
          console.log("取消", err);
        });
    },

    addReply() {
      this.oneReply = {
        keywords: []
      };
    },

    chooseImage(event) {
      let that = this;
      let option = {
        file: event.target.files[0],
        head_name: "autoReply"
      };
      that
        .$uploadImage(option)
        .then(function(res) {
          console.log("upload back", res);
          if (!res) {
            console.log("upload fail");
            return false;
          }
          let temp = JSON.parse(JSON.stringify(that.oneReply));
          temp.img = res;
          that.oneReply = temp;
          that.$nextTick(function() {
            that.$previewRefresh();
          });
        })
        .catch(function(res) {
          console.log("upload fail", res);
        });
    },

    handleCurrentChange(data, node) {
      this.currentData = data;
      this.currentNode = node;
      if (this.operate === "匹配" && this.matchStatus === "已匹配") {
        this.getQuestion();
      }
      if (this.operate === "核对") {
        this.getQuestion();
      }
    },
    async loadNode(node, resolve) {
      let that = this;
      let params = {
        father: "root"
      };
      if (node.level > 0) {
        params.father = node.data.id;
      }
      let res = null;
      try {
        res = await that.$axios.get(that.$url_prefix + "getChildrenTypes", {
          params: params
        });
        console.log("res", res);
      } catch (err) {
        console.log("getChildrenTypes err", err);
      }
      if (res) {
        return resolve(res.data.data);
      } else {
        return resolve([]);
      }
    },
    append(data, node, isDa) {
      let that = this;
      let notice = "新增一级类别";
      let father = "root";
      if (data) {
        notice = `在"${data.name}"下新增类别`;
        father = data.id;
      } else if (isDa) {
        that.$message.error("请选择在哪个答案下新增答案");
        return;
      }
      if (isDa) {
        notice = `在"${data.name}"下新增答案`;
      }
      that
        .$prompt(notice, "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue: ""
        })
        .then(({ value }) => {
          value = value.trim();
          if (value) {
            let obj = {
              father: father,
              name: value,
              status: 1
            };
            let param = {
              db: "AskTypeModel",
              model: "edit",
              item: JSON.stringify(obj)
            };
            if (isDa) {
              obj = {
                way: "数据库",
                type: father,
                name: value,
                status: 1
              };
              param = {
                db: "AutoReplyModel",
                model: "edit",
                item: JSON.stringify(obj)
              };
            }
            that.$axios
              .post(that.$url_prefix + "updateData", param)
              .then(res => {
                if (!res.data.success) {
                  that.$message.error(res.data.msg);
                  return;
                }
                that.$message({
                  type: "success",
                  message: "新增成功"
                });
                let item = {
                  id: res.data.data.id,
                  name: res.data.data.name,
                  type: "type"
                };
                if (isDa) {
                  item.type = "reply";
                  item.oName = item.name;
                } else {
                  if (father === "root") {
                    item.level = 1;
                  } else {
                    item.level = data.level + 1;
                  }
                  item.oName = that.lmap[item.level] + item.name;
                }
                that.$refs.tree.append(item, node);
              })
              .catch(err => {
                console.log("保存失败", err);
                that.$message.error("新增失败");
              });
          }
        })
        .catch(err => {
          console.log("取消修改", err);
        });
    },
    modify(data, node) {
      console.log("node", node);
      let that = this;
      if (!data) {
        return;
      }
      that
        .$prompt(`修改"${data.name}"`, "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue: ""
        })
        .then(({ value }) => {
          value = value.trim();
          if (value && value !== data.name) {
            let obj = {
              id: data.id,
              name: value
            };
            let db = "AskTypeModel";
            if (data.type === "reply") {
              db = "AutoReplyModel";
            }
            let param = {
              db: db,
              model: "edit",
              item: JSON.stringify(obj)
            };
            that.$axios
              .post(that.$url_prefix + "updateData", param)
              .then(res => {
                if (!res.data.success) {
                  that.$message.error(res.data.msg);
                  return;
                }
                node.data.name = value;
                if (data.type === "reply") {
                  node.data.oName = value;
                } else {
                  node.data.oName = that.lmap[data.level] + data.name;
                }
              })
              .catch(err => {
                console.log("保存失败", err);
                that.$message.error("删除失败");
              });
          }
        })
        .catch(err => {
          console.log("取消修改", err);
        });
    },
    remove(data) {
      let that = this;
      if (!data) {
        return;
      }
      that
        .$confirm(`确定删除“${data.name}”？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let obj = {
            id: data.id,
            status: 2
          };
          let db = "AskTypeModel";
          if (data.type === "reply") {
            db = "AutoReplyModel";
          }
          let param = {
            db: db,
            model: "edit",
            item: JSON.stringify(obj)
          };
          that.$axios
            .post(that.$url_prefix + "updateData", param)
            .then(res => {
              if (res.data.success) {
                that.$message({
                  type: "success",
                  message: "删除成功"
                });
                that.$refs.tree.remove(data);
                that.currentData = null;
                that.currentNode = null;
              } else {
                that.$message.error(res.data.msg);
              }
            })
            .catch(err => {
              console.log("保存失败", err);
              that.$message.error("删除失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    filterNode(value, data) {
      if (!value) return true;
      if (value === "match") {
        return data.qnum > 0;
      }
      return data.name.indexOf(value) !== -1;
    },
    toLoadQuestion() {
      let input = document.createElement("input");
      input.type = "file";
      input.addEventListener("change", this.readFile);
      input.click();
    },
    readFile(e) {
      let that = this;
      let files = e.target.files;
      if (!files[0]) {
        return;
      }
      let fileName = files[0].name;
      console.log("fileName", fileName);
      if (fileName.includes(".lxs") || fileName.includes(".xlsx")) {
        that.loadQuestion(files[0]);
      } else {
        that.$message.error("文件格式不支持");
      }
    },
    loadQuestion(file) {
      this.$readExcel(file).then(rows => {
        let list = [];
        rows.forEach(x => {
          if (x["问题"]) {
            list.push(x["问题"]);
          }
        });
        if (list.length) {
          this.uploadQuestion(list);
        } else {
          this.$message.error("没有读取到问题");
        }
      });
    },
    addQuestion() {
      let value = this.questionWords.trim();
      if (value) {
        this.uploadQuestion([value]);
      }
    },
    uploadQuestion(list) {
      let that = this;
      that.$axios
        .post(that.$url_prefix + "uploadQuestion", {
          list: list
        })
        .then(res => {
          console.log("uploadQuestion res", res);
          if (res.data.data.add) {
            that.getQuestion();
          }
          that.$message({
            type: "success",
            message: `上传${res.data.data.total}条，成功${res.data.data.add}条`
          });
        })
        .catch(err => {
          that.$message.error("上传失败");
          console.log("uploadQuestion err", err);
        });
    },
    getQuestion() {
      let that = this;
      that.$open();
      let params = {
        operate: that.operate,
        status: that.operate === "核对" ? that.checkStatus : that.matchStatus,
        checkDate: that.checkDate
      };
      if (!(that.operate === "匹配" && that.matchStatus !== "已匹配")) {
        if (that.currentData && that.currentData.type === "reply") {
          params.answer = that.currentData.id;
        } else {
          that.questionList = [];
          that.$close();
          return;
        }
      }
      that.$axios
        .get(that.$url_prefix + "getQuestionList", {
          params: params
        })
        .then(res => {
          that.$close();
          that.allQuestion = res.data.data;
          this.changePage(1);
        })
        .catch(err => {
          that.$close();
          console.log("getQuestionList err", err);
        });
    },
    matchQuestion(row, oprate) {
      let that = this;
      let answer = that.currentData;
      if (
        !(
          oprate === "wait" ||
          oprate === "delete" ||
          oprate === "diff" ||
          oprate === "silence"
        )
      ) {
        if (!(answer && answer.type === "reply")) {
          that.$message.error("请选择要匹配的答案");
          return;
        }
      }
      that.$axios
        .get(that.$url_prefix + "questionMatchAnswer", {
          params: {
            id: row.id,
            operate: oprate,
            answer: answer && answer.id,
            remark: row.remark
          }
        })
        .then(res => {
          if (res.data.success) {
            if (oprate === "remark") {
              let index = that.questionList.findIndex(x => x.id === row.id);
              that.questionList[index].content = row.remark;
              let index1 = that.allQuestion.findIndex(x => x.id === row.id);
              that.allQuestion[index].content = row.remark;
            } else {
              let index = that.questionList.findIndex(x => x.id === row.id);
              that.questionList.splice(index, 1);
              let index1 = that.allQuestion.findIndex(x => x.id === row.id);
              that.allQuestion.splice(index1, 1);
              if (!that.questionList.length) {
                that.changePage();
              }
            }
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          that.$message.error("匹配失败");
        });
    },
    remarkQuestion(row) {
      let that = this;
      that
        .$prompt(`修改"${row.content}"`, "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue: row.content
        })
        .then(({ value }) => {
          value = value.trim();
          if (value && value !== row.content) {
            row.remark = value;
            that.matchQuestion(row, "remark");
          }
        })
        .catch(err => {
          console.log("取消修改", err);
        });
    },
    joinExamine(e) {
      let that = this;
  
      that.$axios
        .post(that.$url_prefix + "setTestList", {
          id: e.row.id,
          label: "政策测试集",
          add: true
        })
        .then(res => {
          if (res.data.success) {
            that.$set(e.row,'label',['政策测试集'])
          
  

            that.$message("成功加入测试集");
          } else {
            that.$message.error("上传失败");
          }
        })
        .catch(err => {
          that.$message.error("上传失败");
        });
    },

    handleDrop(draggingNode, dropNode, dropType, ev) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "moveAskType", {
          params: {
            fromId: draggingNode.data.id,
            fromType: draggingNode.data.type,
            toId: dropNode.data.id,
            toType: dropNode.data.type,
            dropType: dropType
          }
        })
        .then(res => {
          if (res.data.success) {
            if (dropType === "inner") {
              let dif = dropNode.data.level + 1 - draggingNode.data.level;
              if (dif !== 0) {
                that.changeLevel(draggingNode.data, dif);
              }
            }
            that.$message({
              type: "success",
              message: "移动成功"
            });
          } else {
            that.$message.error("移动失败");
          }
        })
        .catch(err => {
          that.$message.error("移动失败");
        });
    },
    changeLevel(data, dif) {
      let that = this;
      if (data.type === "reply") {
        return;
      }
      data.level = data.level + dif;
      data.oName = that.lmap[data.level] + data.name;
      if (data.children) {
        data.children.forEach(x => {
          that.changeLevel(x, dif);
        });
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      if (!this.movable) {
        return false;
      }
      if (type === "inner") {
        if (dropNode.data.type === "reply") {
          return false;
        }
        if (dropNode.data.children) {
          let find = dropNode.data.children.find(
            x => x.type !== draggingNode.data.type
          );
          if (find) {
            return false;
          }
        }
      } else {
        if (dropNode.data.type !== draggingNode.data.type) {
          return false;
        }
      }
      return true;
    },

    fold() {
      let nodes = this.$refs.tree.store.nodesMap;
      for (let key in nodes) {
        if (nodes[key].level == 1) {
          nodes[key].expanded = false;
        }
      }
    },

    changePage(page) {
      this.tableSearch = "";
      if (page) {
        this.page = page;
      } else {
        page = this.page;
      }
      let size = this.pageSize;
      let rpage = Math.ceil(this.allQuestion.length / size);
      if (page > rpage) {
        page = rpage;
        this.page = rpage;
      }
      this.questionList = this.allQuestion.slice(
        (page - 1) * size,
        page * size
      );
    },

    checkAutoReply(content) {
      let that = this;
      that.$axios
        .post(that.$url_prefix + "judgeAutoReply", {
          estate_id: "jt1ud6tdly",
          content: content
        })
        .then(res => {
          alert(
            res.data.data.label +
              "\n" +
              ((res.data.data.reply && JSON.stringify(res.data.data.reply)) ||
                "")
          );
        });
    }
  }
};
</script>

<style scoped>
.autoReply {
  text-align: center;
  overflow: hidden;
}
.replylist {
  padding: 20px 50px;
}
.edit {
  display: inline-block;
  text-align: left;
}
img {
  width: 100px;
  height: 100px;
}

.table {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 0 30px;
}
.menu {
  width: 25%;
}
.question {
  width: 70%;
}
.input-box {
  display: inline-block;
  width: 50%;
}
.line {
  width: 1px;
  background-color: #000;
}
.mtop {
  margin-top: 30px;
  max-width: 800px;
}
.tree-box {
  overflow-y: scroll;
}

.autoReply
  /deep/
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: #cee2ff !important;
}
</style>



// WEBPACK FOOTER //
// src/page/AutoReply.vue